import { CircularProgress, Box, Stack } from '@mui/material';
import * as React from 'react';
import Logo from './Logo';

const EntireLoadingPage = () => (
    <Box
        sx={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}
    >
        <Stack spacing={7} alignItems="center">
            <Logo />
            <CircularProgress />
        </Stack>
    </Box>
);

export default EntireLoadingPage;
